export default {
  data() {
    return {
      areDisabledButtons: true,
      iconCheckColor: "white",
      images: [],
      showApplyButton: true,
    };
  },
  computed: {
    colors() {
      return this.$store.getters['personalization/getItemsData'][0].font_colors;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    getComponentName() {
      return this.$store.getters['personalization/getPersonalizationComponentName'];
    },
    getPersonalizationData() {
      return this.$store.state.personalization.recipeData;
    },
    itemsToPersonalize() {
      return this.$store.getters['personalization/getItemsData'].length;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    translations() {
      return this.$store.state.translations.data;
    },
  },
  methods: {
    applyPersonalization() {
      this.embroideryApplied = true;
      new Promise((resolve, reject) => {
        this.$personalization
          .applyTextToCanvas({ personalizationComponent: this.getComponentName }, resolve);
      }).then(() => {
        // Set onbeforeunload event
        this.$eventBus.$emit('set-onbeforeunload', true);
        this.startOver();

        if (this.configuration.modals?.embroidery) {
          this.$modal.hide('embroideryModal');
        } else {
          this.$modal.hide('newEmbroideryModal');
        }

        if (!this.configuration.enableAutoRotate ||
          (this.configuration.enableAutoRotate &&
          (this.$store.state.legacyNavigation.activeComponent !== this.getComponentName))) {
          this.$eventBus.$emit('select-component', this.getComponentName);
        }
      });
    },

    changeFontColor(color) {
      if (this.areDisabledButtons || this.iconCheckColor !== color.name) return;
      this.areDisabledButtons = true;
      this.$emit('disableButtons', true);
      this.$eventBus.$emit('hide-customs-spinner', false);
      if (color.name === 'white') {
        this.iconCheckColor = 'black';
      } else {
        this.iconCheckColor = 'white';
      }

      this.$embroideryDataLayer.logAnalyticsEvent({
        eventLabel: color.name,
        action: this.$embroideryDataLayer.action.selectColor
      });

      if (this.getPersonalizationData.length === 0) {
        this.$store.commit(
          'personalization/RESTORE_DATA',
          this.getRecipeComponents()[this.getComponentName].personalization,
        );
        this.$store.commit('ugc/tempData/SET_RECIPE',this.recipe_v2);
        this.showApplyButton = true;
      }
      this.$store.commit('personalization/CHANGE_COLOR', color);
      this.$store.commit('personalization/ADD_PERSONALIZATION_COMPONENT', this.getComponentName);
      this.$personalization.removeDisallowedComponents(this.getComponentName);
      this.$refs.imagesComponent.callImageService();
    },

    /**
     * @function ctaAction
     * @description Handle the click event on the "Apply" button by sending the text to the canvas, and reporting back to analytics.
     * @param MouseEvent
     * @returns undefined
     */
    ctaAction() {
      try {
        this.applyPersonalization();
      } catch (error) {
        console.error('CVC194 Unhandled exception on applyPersonalization', error);
      }
      this.$embroideryDataLayer.logAnalyticsEvent({
        eventLabel: this.$embroideryDataLayer.labels.applyEmbroidery,
      });
    },

    goBackAction() {
      this.$embroideryDataLayer.logAnalyticsEvent({
        eventLabel: this.$embroideryDataLayer.labels.backModal
      });

      this.startOver();
      this.$emit('showBackButton', false);
      this.$eventBus.$emit('set-component-personalization-modal', 'personalizationMainView');
    },

    imagesLoaded(value = true) {
      this.$emit('disableButtons', !value);
      this.areDisabledButtons = !value;
    },

    startOver() {
      this.$store.commit('personalization/RESET_STEP');
      this.$store.commit('personalization/DELETE_DATA');
      this.$store.commit('ugc/tempData/SET_RECIPE', this.recipe_v2);
      this.$eventBus.$emit('close-embroidery-modal', false);
      this.$emit('blockCtaPrimaryButton', true);
      this.$emit('showBackButton', false);
      this.$store.commit('personalization/CHANGE_VIEW', 'personalization-main-view');
      !this.configuration.enableSnapshotService && this.$refs.imagesComponent.callImageService();
    },
  },
  created() {
    this.$emit('showBackButton', true);
    this.$emit('disableButtons', true);
  },
  mounted() {
    if (this.$store.getters['personalization/isPersonalizationInComponentRecipe']() &&
      this.getPersonalizationData.length === 0) {
      this.showApplyButton = false;
      const colorName = this.$store.state.recipe.recipe_v2
        .components[this.getComponentName].personalization[0].color;

      if (colorName === 'white') {
        this.iconCheckColor = 'black';
      } else {
        this.iconCheckColor = 'white';
      }
    }
  }
};
